import React, { ReactNode, useEffect } from "react";

import { ErrorGlobal, Loader } from "src/components";
import { useGetBrandQuery } from "src/graphql-next/generated/queries";
import { useAuthStore } from "src/stores/auth-store";
import { useBrandStore } from "src/stores/brand-store";

export const BrandWrapper = ({ children }: { children: ReactNode }) => {
  const brandCode = useBrandStore((state) => state.brandCode);
  const brand = useBrandStore((state) => state.brand);
  const setBrand = useBrandStore((state) => state.setBrand);
  const logout = useAuthStore((state) => state.logout);

  const { data, error } = useGetBrandQuery({
    code: brandCode,
  });

  useEffect(() => {
    if (data?.brand.__typename === "QueryBrandSuccess") {
      setBrand(data.brand.data);
    }
  }, [data, setBrand]);

  if (error || (data && data.brand.__typename !== "QueryBrandSuccess")) {
    return <ErrorGlobal onLogout={logout} />;
  }

  if (!brand) {
    return <Loader />;
  }

  return <>{children}</>;
};
